import DescriptionIcon from '@mui/icons-material/Description';
import FreeCancellationIcon from '@mui/icons-material/FreeCancellation';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import TableView from '@mui/icons-material/TableView';
import { useTranslation } from 'react-i18next';

import { AreaName } from 'domain/constants';
import {
	calculatorUrl,
	publicationsUrl,
	swkUrl,
} from 'library/components/link/linkUtils';
import { useAdobeTracking } from 'library/hooks/useAdobeTracking';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';
import { maintenancePlannerUrl } from 'main/routes/urls/RouteUrls';

import HomeFooterColumnContainer from './HomeFooterColumnContainer';
import HomeLink from './HomeLink';

const SubApps = (): React.JSX.Element => {
	const { t } = useTranslation(['home']);
	const { trackApplicationInteraction } = useAdobeTracking();

	return (
		<HomeFooterColumnContainer header={t('content-subapplications')}>
			<HomeLink
				area={createArea(
					AreaName.SearchPublication,
					OperationType.Read
				)}
				href={publicationsUrl}
				label={t('home:subapps-publications')}
				icon={<DescriptionIcon />}
				onLinkClick={() =>
					void trackApplicationInteraction({
						action: 'click',
						stepName: 'HOME Sub Applications',
						selectedOptions: [
							{ attribute: 'app', value: 'publications' },
						],
					})
				}
			/>
			<HomeLink
				area={createArea(
					AreaName.MaintenancePlanner,
					OperationType.Read
				)}
				to={maintenancePlannerUrl}
				label={t('home:subapps-maintenancePlanner')}
				icon={<FreeCancellationIcon />}
				onLinkClick={() =>
					void trackApplicationInteraction({
						action: 'click',
						stepName: 'HOME Sub Applications',
						selectedOptions: [
							{ attribute: 'app', value: 'maintenancePlanner' },
						],
					})
				}
			/>
			<HomeLink
				area={createArea(
					AreaName.ServiceCalculation_Search,
					OperationType.Write
				)}
				href={calculatorUrl}
				label={t('home:subapps-serviceCalculator')}
				icon={<TableView />}
				onLinkClick={() =>
					void trackApplicationInteraction({
						action: 'click',
						stepName: 'HOME Sub Applications',
						selectedOptions: [
							{ attribute: 'app', value: 'serviceCalculator' },
						],
					})
				}
			/>
			<HomeLink
				area={createArea(
					AreaName.ShowOrderButtonOnOrderPage,
					OperationType.Read
				)}
				href={swkUrl}
				label={t('home:subapps-orderSoftwareKit')}
				icon={<ShoppingBasketIcon />}
				onLinkClick={() =>
					void trackApplicationInteraction({
						action: 'click',
						stepName: 'HOME Sub Applications',
						selectedOptions: [
							{ attribute: 'app', value: 'orderSoftwareKit' },
						],
					})
				}
			/>

			{/* Activate once FLOP team is ready
			<HomeLink
				area={createArea(
					AreaName.RemoteReadout,
					OperationType.Read
				)}
				href={fleetOperationsUrl}
				label={"Fleet Operations"}
				icon={<ShoppingBasketIcon />}
				onLinkClick={() =>
					void trackApplicationInteraction({
						action: 'click',
						stepName: 'HOME Sub Applications',
						selectedOptions: [
							{ attribute: 'app', value: 'fleetOperations' },
						],
					})
				}
			/>
			*/}
		</HomeFooterColumnContainer>
	);
};

export default SubApps;
